var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import cn from 'classnames';
import * as React from 'react';
import { Children } from 'react';
import { cloneElement } from 'react';
import { isValidElement } from 'react';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown, } from 'reactstrap';
import style from './Selectbox.module.scss';
export function Selectbox(props) {
    var _a = props.menuOptions, menuOptions = _a === void 0 ? {} : _a, _b = props.theme, theme = _b === void 0 ? {} : _b, _c = props.pending, pending = _c === void 0 ? false : _c, _d = props.caret, caret = _d === void 0 ? true : _d, onChange = props.onChange, className = props.className, value = props.value, options = props.options, children = props.children, renderOption = props.renderOption, _e = props.disabled, disabled = _e === void 0 ? false : _e, _f = props.invalid, invalid = _f === void 0 ? false : _f;
    return (React.createElement(UncontrolledDropdown, { className: cn(style.container, className, theme.container) },
        React.createElement(DropdownToggle, { disabled: disabled || pending, color: theme.buttonColor, caret: caret, className: cn(style.button, theme.button, invalid && style.button_invalid) }, renderOption(value)),
        React.createElement(DropdownMenu, __assign({ className: cn('max-height-dropdown', theme.menu) }, menuOptions), options
            ? options.map(function (project, index) { return (React.createElement(DropdownItem, { key: index, onClick: function () { return onChange === null || onChange === void 0 ? void 0 : onChange(project); }, active: project === value }, renderOption(project))); })
            : Children.map(children, function (child) {
                if (isValidElement(child) && typeof child.props.value !== 'undefined') {
                    return cloneElement(child, { onClick: function () { return onChange === null || onChange === void 0 ? void 0 : onChange(child.props.value); } });
                }
                else {
                    return child;
                }
            }))));
}
export function Option(props) {
    return React.createElement(DropdownItem, __assign({}, props));
}
export function Header(_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return React.createElement("div", __assign({ className: cn('dropdown-header', style.header, className) }, rest));
}
//# sourceMappingURL=Selectbox.js.map